module.exports = __webpack_public_path__ + "static/media/831NorthAvenueNW_2018-07-09_149.ed9669ab.jpg";